import { useEffect, useState } from "react";
import axios from "axios";
import { Gift } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (n) => `$${Number(n || 0).toFixed(2)}`;
const date = (d) => (d ? new Date(d).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }) : "No expiry");

export function CustomerCredits() {
  const [data, setData] = useState(null);
  useEffect(() => {
    const token = localStorage.getItem("mahra_session_token");
    axios.get(`${API}/rental-credits/mine`, { withCredentials: true, headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then((r) => setData(r.data)).catch(() => setData(null));
  }, []);
  if (!data?.credits?.length) return null;
  return (
    <div className="mb-8 bg-white border border-[#282828]/8 p-6 lg:p-8" data-testid="customer-credits-section">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-sm text-[#282828] font-medium flex items-center gap-2"><Gift className="w-4 h-4 text-[#9A7B4F]" /> Mahra Rental Credit</h2>
        <div className="text-[13px] text-[#9A7B4F] font-medium" data-testid="customer-credit-available">{fmt(data.available_total)} available</div>
      </div>
      <div className="space-y-4">
        {data.credits.map((c) => (
          <div key={c.number} className="border border-[#282828]/8 p-4" data-testid={`customer-credit-${c.number}`}>
            <div className="flex justify-between text-[13px]">
              <span className="font-mono text-[#282828]">{c.number}</span>
              <span className="text-[#282828] font-medium">{fmt(c.balance)} <span className="text-[#676664]/50 font-normal">of {fmt(c.original_amount)}</span></span>
            </div>
            <div className="text-[11px] text-[#676664]/60 mt-1">{c.status.replace(/_/g, " ")} · Expires {date(c.expires_at)}{c.reason ? ` · ${c.reason}` : ""}</div>
            {c.history.length > 0 && (
              <ul className="mt-3 space-y-1 text-[11px] text-[#676664]">
                {c.history.map((h, i) => (
                  <li key={i} className="flex justify-between"><span>{date(h.at)} · booking {h.booking_id.toUpperCase()}</span><span>{h.state === "returned" ? `−${fmt(h.amount)} · returned to your credit` : `−${fmt(h.amount)}${h.state === "pending" ? " (awaiting payment)" : ""}`}</span></li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
      <p className="text-[10px] text-[#676664]/50 mt-4">Use your credit at checkout towards rental fees. It can't be used for bonds, delivery or other charges.</p>
    </div>
  );
}
